(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
if (!customElements.get('fh-collection-description')) {
  customElements.define('fh-collection-description', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.fh-collection-description__content');
      this.button = this.querySelector('button');
      this.hero = this.closest('.collection-hero');
      this.image = this.hero.querySelector('.collection-hero__image-container');
      this.expanded = false;
      this.update = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.measure());
      };
      this.toggle = () => { this.expanded = !this.expanded; this.apply(); };
      this.button.addEventListener('click', this.toggle);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.hero.querySelector('.collection-hero__inner'));
      if (this.image) this.observer.observe(this.image);
      this.image?.querySelector('img')?.addEventListener('load', this.update);
      document.fonts.ready.then(this.update);
      this.update();
    }
    measure() {
      const desktop = matchMedia('(min-width: 750px)').matches;
      const imageHeight = this.image?.getBoundingClientRect().height || 0;
      const title = this.hero.querySelector('h1');
      const offset = this.getBoundingClientRect().top - title.getBoundingClientRect().top;
      const target = desktop && imageHeight > 0 ? imageHeight - offset - 48 : Math.min(imageHeight || 320, 320);
      this.limit = Math.max(120, Math.floor(target));
      this.style.setProperty('--fh-description-height', this.limit + 'px');
      this.overflowing = this.content.scrollHeight > this.limit + 2;
      this.button.hidden = !this.overflowing;
      this.apply();
    }
    apply() {
      const collapsed = this.overflowing && !this.expanded;
      this.content.classList.toggle('is-collapsed', collapsed);
      this.button.setAttribute('aria-expanded', String(this.expanded));
      this.button.textContent = this.expanded ? this.button.dataset.less : this.button.dataset.more;
      const bottom = this.content.getBoundingClientRect().top + this.limit;
      this.content.querySelectorAll('a').forEach(link => {
        if (collapsed && link.getBoundingClientRect().bottom > bottom) {
          if (!link.hasAttribute('data-fh-tabindex')) link.dataset.fhTabindex = link.getAttribute('tabindex') || '';
          link.setAttribute('tabindex', '-1');
        } else if (link.hasAttribute('data-fh-tabindex')) {
          const original = link.dataset.fhTabindex;
          if (original) link.setAttribute('tabindex', original); else link.removeAttribute('tabindex');
          delete link.dataset.fhTabindex;
        }
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.toggle);
      this.image?.querySelector('img')?.removeEventListener('load', this.update);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
